export default __webpack_public_path__ + "static/media/SpencerPortrait(2).7d82fd0d.jpg";